export default __webpack_public_path__ + "static/pg-44418f24a5ff5fea98b5c54af211c918.png";